import { useCallback } from 'react';
import { useError } from '../contexts/ErrorContext';

export const useApiWithErrorHandling = () => {
  const { showNetworkError } = useError();

  const executeWithErrorHandling = useCallback(async (apiCall, customErrorMessage) => {
    try {
      return await apiCall();
    } catch (error) {
      if (error.message === 'NETWORK_ERROR') {
        showNetworkError(customErrorMessage);
        throw error; // Re-throw to maintain original behavior for other error handling
      }
      throw error; // Re-throw non-network errors
    }
  }, [showNetworkError]);

  return { executeWithErrorHandling };
};